import { Flex, Row, Spin } from "antd";
import { KanbanLane } from "./components/KanbanLane";
import { useQuery } from "@tanstack/react-query";
import { fetchWorkflowStates } from "../../../lib/api/resources/workflows";
import { fetchDossiersGroupedByStatus } from "../../../lib/api/resources/dossiers";

export default function KanbanOverview() {
  // const [query, setQuery] = useState("");

  const dossiersQuery = useQuery({
    queryKey: ["dossiers", "by-status"],
    queryFn: fetchDossiersGroupedByStatus,
  });

  const dossiers = dossiersQuery.data || {};

  const workflowStatesQuery = useQuery({
    queryKey: ["workflow", "states"],
    queryFn: fetchWorkflowStates,
  });

  const workflowStates = workflowStatesQuery.data?.member || [];

  const lanes = workflowStates.map((state) => ({
    key: state.name,
    label: state.label,
  }));

  // Client-side text filtering per lane (TODO: move server-side)
  // const filterFn = (arr: Claim[] = []) => {
  //   const q = query.toLowerCase();
  //   if (!q) return arr;
  //   return arr.filter(
  //     (dossier) =>
  //       dossier.vehicle.licensePlate.identifier.toLowerCase().includes(q) ||
  //       dossier.driver.person.fullName.toLowerCase().includes(q),
  //   );
  // };

  return (
    <div style={{ padding: 16 }}>
      <Flex vertical gap={16}>
        {/* <KanbanFilters />
        <Divider style={{ margin: 0 }} /> */}

        {dossiersQuery.isLoading ? (
          <Spin />
        ) : (
          <Row className="overflow-x-scroll flex-nowrap" gutter={[16, 16]}>
            {lanes.map((lane) => {
              const dossiersByLane = dossiers[lane.key] || [];

              return (
                <KanbanLane
                  key={lane.key}
                  title={lane.label}
                  dossiers={dossiersByLane}
                />
              );
            })}
          </Row>
        )}
      </Flex>
    </div>
  );
}
